import { SuiteManifest } from '../manifest';
import { schedulingRoutes } from './routes';

export const schedulingManifest: SuiteManifest = {
  id: 'scheduling',
  code: 'S3_SCHED',
  name: 'Batch & Scheduling',
  basePath: '/scheduling',
  icon: 'calendar',
  description: 'Clash-free timetable builder with GiST exclusion constraints, batch capacity, master classes, and 1-on-1 pairings.',
  requiredPermission: 'schedule.read',
  nav: [
    { label: 'Timetable Builder', path: '/scheduling/timetable', icon: 'clock', group: 'Schedule', status: 'live' },
    { label: 'Batch Directory', path: '/scheduling/batches', icon: 'layers', group: 'Capacity', status: 'live', permission: 'batches.manage', allowedRoles: ['owner', 'admin', 'branch_head', 'counselor', 'teacher'] },
    { label: 'Classrooms & Labs', path: '/scheduling/rooms', icon: 'building', group: 'Capacity', status: 'live', permission: 'rooms.manage', allowedRoles: ['owner', 'admin', 'branch_head'] },
    { label: 'Academic Calendar', path: '/scheduling/calendar', icon: 'calendar', group: 'Schedule', status: 'live' },
    { label: 'Master Class Scheduler', path: '/scheduling/master-classes', icon: 'video', group: 'Live Tuition', status: 'live', permission: 'sessions.manage', allowedRoles: ['owner', 'admin', 'branch_head', 'teacher'] },
    { label: 'Faculty-Student Pairing', path: '/scheduling/assignments', icon: 'user-check', group: 'Live Tuition', status: 'live', allowedRoles: ['owner', 'admin', 'branch_head', 'teacher'] },
  ],
  routes: schedulingRoutes,
};

export default schedulingManifest;
